/**
 * Created by neo on 18.08.23
 */
import {
  SubscribedOfflineMeetingEventEntry,
  SubscribedOfflineMeetingEventEntryJson,
  createSubscribedOfflineMeetingEventEntry,
} from './SubscribedOfflineMeetingEventEntry';
import { HttpBackend } from '../../../Services/Http/HttpBackend';
import { EventEntrySearchParams } from './SubscribedEventEntry';

export type OfflineMeetingWaitlistEntryJson = SubscribedOfflineMeetingEventEntryJson;

export type OfflineMeetingWaitlistEntry = SubscribedOfflineMeetingEventEntry;

export function createOfflineMeetingWaitlistEntry(json?: Partial<OfflineMeetingWaitlistEntryJson>): OfflineMeetingWaitlistEntry {
  return createSubscribedOfflineMeetingEventEntry({ type: 'event.subscribed.waitlist', ...json } as any);
}

export const OfflineMeetingWaitlistEntryApi = {
  findExisting(params: EventEntrySearchParams): Promise<OfflineMeetingWaitlistEntry | undefined> {
    return HttpBackend.get('/coach/schedule/event/subscription/waitlist', Object.assign(params, { size: 1 }))
      .then((res) => (res ? createOfflineMeetingWaitlistEntry(res) : undefined))
      .catch(() => undefined);
  },
};
